module.exports = __webpack_public_path__ + "img/login-logo.6fe0b276.png";